import { Tag } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch } from "../../../../../redux/store";
import { PopupConfirm } from "../../../../atoms/Popup";
import { getBookingDetail } from "../../ducks/actions";
import { ApprovalHeader } from "../utils";
import { useUpdateEarlyTerminationDecision } from "./api/v1";

export const EarlyTerminationApprovalActions = () => {
  const { leaseId } = useParams();
  const dispatch = useDispatch<AppDispatch>();

  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [isRejectLoading, setIsRejectLoading] = useState(false);

  const { updateEarlyTerminationDecision, isSuccess } = useUpdateEarlyTerminationDecision({
    onSuccess: () => {
      dispatch(getBookingDetail(leaseId));
      setIsApproveLoading(false);
      setIsRejectLoading(false);
    },
    onError: () => {
      setIsApproveLoading(false);
      setIsRejectLoading(false);
    },
  });

  const approveEarlyTermination = () => {
    PopupConfirm({
      title: "Are you sure you want to approve lease termination request?",
      okText: "Confirm",
      onOk: () => {
        setIsApproveLoading(true);
        updateEarlyTerminationDecision({ leaseId, status: "approved" });
      },
    });
  };

  const rejectEarlyTermination = () => {
    setIsRejectLoading(true);
    updateEarlyTerminationDecision({ leaseId, status: "rejected" });
  };

  if (isSuccess) return null;

  return (
    <Tag className="fm-status-header" color="cyan" style={{ margin: "18px 0 0" }}>
      <ApprovalHeader
        title="Approval required for lease termination"
        approve={approveEarlyTermination}
        reject={rejectEarlyTermination}
        isApproveLoading={isApproveLoading}
        isRejectLoading={isRejectLoading}
      />
    </Tag>
  );
};
